import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { exchangeSession } from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { Loader2 } from "lucide-react";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth() || {};
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match?.[1];

    if (!sessionId) {
      navigate("/", { replace: true });
      return;
    }

    exchangeSession(sessionId)
      .then((user) => {
        setUser?.(user);
        navigate("/dashboard", { replace: true, state: { user } });
      })
      .catch(() => navigate("/", { replace: true }));
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="text-center">
        <Loader2 className="h-8 w-8 animate-spin text-amber mx-auto mb-3" />
        <p className="text-zinc-400 font-heading text-sm uppercase tracking-[0.22em]">Authenticating…</p>
      </div>
    </div>
  );
}
